/**
 * Яндекс.Метрика.
 *
 * Счётчик подключает сервер, подставляя код в index.html и выставляя
 * window.METRIKA_ID. Здесь только отправка событий — если счётчик не настроен
 * или скрипт заблокирован, все вызовы молча ничего не делают.
 *
 * Приложение одностраничное, поэтому переходы между экранами Метрика сама
 * не увидит: их нужно отправлять вручную.
 */
declare global {
  interface Window {
    METRIKA_ID?: number;
    ym?: (id: number, action: string, ...args: unknown[]) => void;
  }
}

function send(action: string, ...args: unknown[]): void {
  const id = window.METRIKA_ID;
  if (!id || typeof window.ym !== 'function') return;
  try {
    window.ym(id, action, ...args);
  } catch {
    // Аналитика не имеет права ломать игру.
  }
}

/** Переход на экран — считается просмотром страницы. */
export function trackScreen(name: string): void {
  send('hit', `/${name}`, { title: name });
}

/** Достижение цели: начал игру, закончил, создал дуэль. */
export function trackGoal(goal: string, params?: Record<string, unknown>): void {
  send('reachGoal', goal, params);
}
